import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';

import DataTable from "./DataTable";
import SearchField from "../table-common/SearchField";
import ExportButton from "../table-common/ExportButton";
import {formatForExport, processDataToList} from "./condition-processing";
import {filterBearingItems} from "../table-common/table-search";
import {getBearingSortingFunction} from "../table-common/table-sorting";

const ConditionMonitoringView = ({
                                   ConditionService,
                                   fleetService,
                                   userService,
                                   userViewService,
                                   bearingConditionExportService,
                                   $uibModal,
                                   $state,
                                   __env
                                 }) => {
  useEffect(() => {
    userViewService.setView('condition-monitoring');
  }, [userViewService]);

  const tabOptions = [
    {tab: "DOORS", displayName: "Doors", assetType: "DOOR-CONTROLLER", visible: __env.profile === 'DEMO'},
    {tab: "BOGIE", displayName: "Axle Bearing", assetType: "BOGIE", visible: __env.profile === 'DEMO' || __env.profile === 'VALE'},
    {tab: "HVAC", displayName: "HVAC", assetType: "HVAC-CONTROLLER", visible: __env.profile === 'DEMO'},
  ].filter(tab => tab.visible);
  const [tab, setTab] = useState(tabOptions[0].tab);
  const tabToAssetType = () => {
    return tabOptions.find(tabOption => tabOption.tab === tab).assetType;
  };

  let [loading, setLoading] = useState(true);
  let [loadedData, setLoadedData] = useState([]);
  const load = async () => {
    setLoading(true);
    setLoadedData(processDataToList(await ConditionService.getAssetConditions({
      assetType: tabToAssetType()
    })));
    setLoading(false);
  };

  let [searchBy, setSearchBy] = useState("");
  let [sortingBy, setSortingBy] = useState('status');
  let [sortReversed, setSortReversed] = useState(false);
  const changeSort = (newType, descending) => {
    if (sortingBy === newType) {
      setSortReversed(!sortReversed);
    } else {
      setSortingBy(newType);
      setSortReversed(descending === undefined || descending);
    }
  };

  useEffect(() => {
    load();
    setSortingBy('status');
    setSortReversed(false);
  }, [ConditionService, tab]);

  let [visibleData, setVisibleData] = useState([]);
  useEffect(() => {
    // Updates visible data when data is loaded, sort or search changes.
    setVisibleData(loadedData
      .filter(filterBearingItems(searchBy))
      .sort(getBearingSortingFunction(sortingBy, sortReversed)));
  }, [loadedData, searchBy, sortingBy, sortReversed]);

  const exportExcel = async () => {
    await bearingConditionExportService.exportToExcel(formatForExport(visibleData, tab), 'latest-conditions-' + tab.toLowerCase());
  };
  const exportCsv = async () => {
    await bearingConditionExportService.exportToCsv(formatForExport(visibleData, tab), 'latest-conditions-' + tab.toLowerCase());
  };
  const exportOptions = [
    {name: 'Export Excel', exportFunction: exportExcel},
    {name: 'Export CSV', exportFunction: exportCsv}
  ];

  const seeCarView = userService.hasCarViewRead();
  const goToCar = carNumber => {
    fleetService.getTrainsWithCars().then(data => {
      const found = data.find(trainDto => trainDto.cars.includes(carNumber));
      return found ? found.trainId : 'detached';
    }).then(trainId => {
      $state.go('car', {carNumber, trainId});
    });
  };

  return (
    <div id="condition-monitoring-container" className="common-view-container-style">
      <div className="page-container">
        <h3 className="tabTitle"><span>Condition Monitoring</span> <button type="button" className="refresh-button"
          aria-label="Refresh condition monitoring" data-testid="condition-monitoring-refresh" onClick={load}>
          <i className={loading ? "fa fa-fw fa-spin fa-sync" : "fa fa-fw fa-redo"}/></button>
          <SearchField value={searchBy} setValue={setSearchBy}/>
          <ExportButton exportOptions={exportOptions}/>
        </h3>
        {tabOptions.length > 1 && <Tabs tab={tab} setTab={setTab} tabOptions={tabOptions}/>}
        {loading ? <div className="loading-overlay"/> : ''}
        <DataTable
          tab={tab}
          data={visibleData}
          searchBy={searchBy}
          sorting={{sortingBy, sortReversed, changeSort}}
          $uibModal={$uibModal}
          seeCarView={seeCarView}
          goToCar={goToCar}/>
      </div>
    </div>
  );
};

const Tabs = ({tab, setTab, tabOptions}) => {
  return (
    <ul className={"tab-list"}>
      {tabOptions.map(tabOption => {
        return (
          <li className={"tab-item " + (tabOption.tab === tab ? "tab-selected" : "")}>
            <button onClick={() => setTab(tabOption.tab)}>{tabOption.displayName}</button>
          </li>
        )
      })}
    </ul>
  )
}

ConditionMonitoringView.propTypes = {
  ConditionService: PropTypes.object,
  userViewService: PropTypes.object
};

export default ConditionMonitoringView;